<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title has-text-weight-medium">
                {{ note.strLinkType }}
            </p>
            <button
                class="delete"
                aria-label="close"
                @click="$parent.close()"
            />
        </header>
        <section class="modal-card-body">
            <p>
                {{ note.memNote }}
            </p>

            <p
                v-if="note.AddressString"
                class="has-text-grey"
            >
                Property: {{ note.AddressString }}
            </p>

            <p v-if="note.documentCount">
                <Notification v-if="! documents">
                    Loading attachments...
                </Notification>

                <Notification v-if="documents && ! documents.length">
                    No attachments found.
                </Notification>
            </p>

            <hr v-if="note.documentCount" />

            <div
                v-for="document in documents"
                :key="document.DocumentPK"
                class="is-block mb-4"
            >
                <h6 class="title is-6 mb-2">
                    {{ document.strDocument }}
                </h6>

                <DocumentViewButton
                    v-if="$meta.features.pdf_viewer"
                    :document="document"
                />

                <DocumentDownloadButton :document="document" />
            </div>

            <p>
                <small class="is-size-7 has-text-grey">
                    {{ note.dteRegisteredDate | formatDateTime }}
                </small>
            </p>
        </section>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Notification from './Notification.vue';
import DocumentDownloadButton from './DocumentDownloadButton.vue';
import DocumentViewButton from './DocumentViewButton.vue';

export default {
    components: {
        Notification,
        DocumentDownloadButton,
        DocumentViewButton,
    },

    props: {
        note: {
            type: Object,
            required: true,
        },
    },

    computed: {
        ...mapState('notes', [
            'documents',
        ]),
    },

    mounted() {
        this.getRows();
    },

    methods: {
        getRows() {
            if(this.note.documentCount) {
                this.$store.dispatch('notes/getDocuments', this.note.NotePK);
            }
        },
    },
};
</script>
